import { render, staticRenderFns } from "./SpecializationEdit.vue?vue&type=template&id=04963894&scoped=true"
import script from "./SpecializationEdit.vue?vue&type=script&lang=js"
export * from "./SpecializationEdit.vue?vue&type=script&lang=js"
import style0 from "./SpecializationEdit.vue?vue&type=style&index=0&id=04963894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04963894",
  null
  
)

export default component.exports